export default __webpack_public_path__ + "static/media/CGOL.58f64f84.gif";